// Shop settings sent by the server (currency, VAT, company data; see server/siteInfo.js).
// App loads them on start. The last known values are kept in localStorage so the footer
// and prices do not show up empty while the server answers.

const EMPTY = {
    siteUrl: '',
    siteHost: '',
    currency: '',
    vatRate: null,
    englishEurRate: null,
    company: {}
};

let current = readCached();

function readCached() {
    try {
        if (localStorage.siteConfig) {
            return JSON.parse(localStorage.siteConfig);
        }
    } catch (e) { }
    return EMPTY;
}

export function getSiteConfig() {
    return current;
}

export function setSiteConfig(config) {
    current = config || EMPTY;
    try {
        localStorage.siteConfig = JSON.stringify(current);
    } catch (e) { }
}

// The same build serves every shop: autoin.ba -> socket.autoin.ba, autoin.co.me -> socket.autoin.co.me
export function socketUrl() {
    if (process.env.REACT_APP_SOCKET_URL) {
        return process.env.REACT_APP_SOCKET_URL;
    }
    let host = window.location.hostname.replace(/^(www|admin)\./, '');
    if (host === 'localhost' || /^[0-9.]+$/.test(host)) {
        return 'https://socket.autoin.ba';
    }
    return 'https://socket.' + host;
}
